<template>

    <TemplateBasic 
      v-bind:breadcrumb="breadcrumb"
      v-bind:permission="permission">

      <div class="row form-group">

        <div v-show="pageShowData" class="col">
          <AppAddButton v-bind:permission="permission">
          <button @click.prevent="onAddButtonClick" class="btn btn-rounded btn-info btn-block-xs-only" style="background: rgb(133, 201, 47); color: #fff;">
            Add Product Fees
          </button>
          </AppAddButton>
        </div>

        <AppSearch 
          v-show="false"
          class="col-md-4" />
        
      </div>
      
      <h3 v-show="pageShowData">Active Product Fees</h3>

      <AppTable 
        ref="activeTable" 
        v-bind:tableParameter="PARAM" 
        v-bind:permission="permission"
        v-on:table-data-click="onTableDataClick" 
        v-on:table-page-change="onTablePageChange" />

      <h3 v-show="pageShowData">Future Product Fees</h3>

      <AppTable 
        ref="futureTable" 
        v-bind:tableParameter="PARAM" 
        v-bind:permission="permission"
        v-on:table-data-click="onTableDataClick" 
        v-on:table-page-change="onTablePageChange" />

      <h3 v-show="pageShowData">Past Product Fees</h3>

      <AppTable 
        ref="pastTable" 
        v-bind:tableParameter="PARAM" 
        v-bind:permission="permission"
        v-on:table-data-click="onTableDataClick" 
        v-on:table-page-change="onTablePageChange" />

      <TemplateFeedback ref="pageFeedback" />

      <AppModalForm 
        ref="pageModal" 
        v-bind:formParameter="PARAM" 
        v-bind:permission="permission"
        v-on:modal-data-add="onModalAddDataClick"
        v-on:modal-data-edit="onModalEditDataClick"
        v-on:modal-data-delete="onModalDeleteDataClick"
        v-on:modal-data-input="onFormInput" >

        <!-- <template
          slot="jt-form-slot-Deposit">
          <div class="row">
            <input 
              ref="pageQuarterly"
              type="Number" 
              class="form-control col-5">
            <span class="col-2">x 3</span>
            <input 
              ref="pageQuarterlyTotal"
              type="Number" 
              class="form-control col-5">
          </div>
        </template> -->

        <button 
          v-show="activeButtonVisible && helper.hasAddPermission('productfee')"
          slot="modal-footer-after" 
          type="button" 
          class="btn btn-primary"
          v-on:click.prevent="onActiveButtonClick">
          ACTIVATE Fees
        </button>
      </AppModalForm>

      <TemplateModal
        v-bind:modalId="'jt-product-active-date-modal'">
        <h4 slot="modal-title" class="modal-title" >
          Activate Product Fees
        </h4>
        <div slot="modal-body">
          {{ `Are you sure you want to change Product Fees Start Date to ${activeModalDate} and set it to Active?` }}
        </div>
        <div slot="modal-footer">
          <button type="button" class="btn btn-default" data-dismiss="modal">
            Close
          </button>
          <button @click="onChangeDateConfirmClick" type="button" class="btn btn-danger">
            Confirm
          </button>
        </div>
      </TemplateModal>

      <TemplateModal
        v-bind:modalId="'jt-product-active-confirm-modal'">
        <h4 slot="modal-title" class="modal-title" >
          Activate Product Fees
        </h4>
        <div slot="modal-body">
          Are you sure you want to set this product fees to Active?
        </div>
        <div slot="modal-footer">
          <button type="button" class="btn btn-default" data-dismiss="modal">
            Close
          </button>
          <button @click="onActiveConfirmClick" type="button" class="btn btn-danger">
            Confirm
          </button>
        </div>
      </TemplateModal>

    </TemplateBasic>

</template>

<script>
import TemplateBasic from "@/components/Template/TemplateBasic";
import TemplateButton from "@/components/Template/TemplateButton";
import TemplateFeedback from "@/components/Template/TemplateFeedback";
import TemplateModal from "@/components/Template/TemplateModal";
import AppSearch from "@/components/App/AppSearch";
import AppPaging from "@/components/App/AppPaging";
import AppTable from "@/components/App/AppTable";
import AppAddButton from "@/components/App/AppAddButton";
import AppModalForm from "@/components/App/AppModalForm";
import validation from "@/components/Utility/Validation"
import helper from "@/components/Utility/Helper"
import AppFormInputFees from "@/components/App/AppFormInputFees";

var querystring = require('querystring');
var moment = require('moment');

let commencementDateValidate = function(date) {
  return true;
}

const PARAM = [
  {
    key: '_productName',
    text: 'Product Name',
    table_popup: true, 
    form_invalid: true,
  },
  {
    key: '_productStatus',
    text: 'Status',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];
      if(dataItem[parameterItem.key] === 'Active') {
        return '<span class="badge badge-sm badge-success">Active</span>';
      } else if(dataItem[parameterItem.key] === 'Past') {
        return '<span class="badge badge-sm badge-secondary">Past</span>';
      } else {
        return '<span class="badge badge-sm badge-warning">Future</span>';
      }
    },
    form_invalid: true,
  },
  {
    key: 'deposit',
    text: 'Deposit',
    form_input_attr: {
      'type': 'Number',
    },
  },
  {
    key: 'establishment',
    text: 'Establishment',
    form_label: 'Establishment Fee',
    form_input_attr: {
      'type': 'Number',
    },
  },
  {
    key: 'PasscardFees',
    text: 'Passcard Fees ',
    form_input_attr: {
      'type': 'Number',
    },
  },
  {
    key: 'monthly',
    text: 'Monthly',
    form_label: 'Parking Fee (Monthly)',
    form_input_attr: {
      'type': 'Number',
    },
  },
  {
    key: 'quarterly',
    text: 'Quarterly',
    form_label: 'Parking Fee (Quarterly)',
    form_input_attr: {
      'type': 'Number',
    },
    form_component: AppFormInputFees,
    form_multiplier: 3,
  },
  {
    key: 'halfYearly',
    text: 'Half-Yearly',
    form_label: 'Parking Fee (Half-Yearly)',
    form_input_attr: {
      'type': 'Number',
    },
    form_component: AppFormInputFees,
    form_multiplier: 6,
  },
  {
    key: 'annually',
    text: 'Annually',
    form_label: 'Parking Fee (Yearly)',
    form_input_attr: {
      'type': 'Number',
    },
    form_component: AppFormInputFees,
    form_multiplier: 12,
  },
  {
    key: 'lost',
    text: 'Lost Card',
    form_label: 'Lost Card Fee',
    form_input_attr: {
      'type': 'Number',
    },
  },
  {
    key: 'damage',
    text: 'Damage Card',
    form_label: 'Damage Card Fee',
    form_input_attr: {
      'type': 'Number',
    },
  },
  {
    key: '_StartDate',
    text: 'Start Date',
    form_label: 'Product Fees Start Date',
    form_datepicker: {
      beforeShowDay: function(date) {
        return commencementDateValidate(date);
      },
    },
  },
  {
    key: '_createDate',
    form_label: 'Product Fees Create Date',
    table_hide: true,
    form_add_hide: true,
    form_input_validation: [],
  }
];
const PARAM_MAP = helper.transformParamToMap(PARAM);

export default {
  name: "PageProductFees",
  components: {
    TemplateBasic,
    TemplateButton,
    AppSearch,
    AppPaging,
    AppTable,
    AppAddButton,
    AppModalForm,
    TemplateFeedback,
    TemplateModal,
  },
  data () {
    return {
      helper : helper,
      permission : null,
      breadcrumb : [
        { name: 'Home', url: helper.WEB_URL },
        { name: 'Car Park', url: '/carpark' },
        { name: 'Product', url: '/product' },
      ],

      PARAM,
      PARAM_MAP,
      
      pageShowData: false,
      pageSeason: null,
      deleteButtonVisible: false,
      activeButtonVisible: false,
      activeModalDate: null,
    }
  },
  mounted() {
    if(!helper.hasViewPermission(this.permission = helper.getPermission(this))) {
      return;
    }

    this.$nextTick(() => {
      helper.setSidebar('/product');
    });
    
    this.$refs['pageModal'].modalCanEdit = false;
    this.$refs['pageModal'].formatModalConfirmDeleteTitle = (formData) =>  `Confirm Remove Parking Fees`;
    this.$refs['pageModal'].formatModalConfirmDeleteBody = (formData) =>  `Confirm remove parking fees on date ${helper.formatDate(formData['startDate'])}?`;

    this.loadConfigure();
  },
  methods: {
    loadConfigure() {
      this.$refs['pageFeedback'].setFeedbackLoading('Loading configuration data...');
      this.$http
        .get(
          helper.SERVER_URL + '/api2/configure',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.pageConfigure = response.data[0] || {};
          this.loadProduct();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'configuration data'));
        })
    },
    loadProduct() {
      this.$refs['pageFeedback'].setFeedbackLoading('Loading product data...');

      let productID = this.$route.query.productID;

      this.$http
        .get(
          helper.SERVER_URL + '/api2/season/' + productID,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.pageSeason = response.data[0];
          if(this.pageSeason) {
            this.$refs['pageFeedback'].setFeedbackMessage();
            this.pageTitle = 'Edit ' + this.pageSeason.name;
            this.loadData();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('Problem loading product data.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'product data'));
        })
    },
    loadData() {
      this.pageShowData = false;

      this.$refs['pageFeedback'].setFeedbackLoading('Loading fees data...');

      this.$http
        .get(
          this.getUrl(),
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          this.pageSeasonFee = response.data;
          response.data.forEach(product => {
            product['_productName'] = this.pageSeason.name;
            if(product.isActive) {
              product['_productStatus'] = 'Active';
            } else if(product.isPast) {
              product['_productStatus'] = 'Past';
            } else {
              product['_productStatus'] = 'Future';
            }

            product['_StartDate'] = helper.formatDate(product['startDate']);
            product['_createDate'] = helper.formatDateTime(product['createDate']);
          });

          if(response.data.length > 0) {
            this.PARAM_MAP['_StartDate'].form_default = new moment().add(1, 'month').startOf('month').format('YYYY-MM-DD');
          }

          try {
            let self = this;
            commencementDateValidate = function(date) {
              if(self.pageSeasonFee && self.pageSeasonFee.length > 0) {
                if(date.getDate() !== 1 || date < new Date()) {
                  return false;
                }
              } else {
                if(date.getTime() < (self.pageSeason.startDate * 1000)) {
                  return false;
                }
              }
              return true;
            }
            $('#jt-form-input-_StartDate').datepicker('update');
          } catch (e) {
          }
          
          if(this.pageConfigure.isSellPasscard) {
            this.PARAM_MAP['PasscardFees'].table_hide = false;
            this.PARAM_MAP['PasscardFees'].form_hide = false;
          } else {
            this.PARAM_MAP['PasscardFees'].table_hide = true;
            this.PARAM_MAP['PasscardFees'].form_hide = true;
            this.PARAM_MAP['PasscardFees'].form_input_validation = [];
          }

          this.pageSeasonFeesActive = response.data.filter(k => k.isActive) || [];
          this.pageSeasonFeesPast = response.data.filter(k => k.isPast) || [];
          this.pageSeasonFeesFuture = response.data.filter(k => !k.isPast && !k.isActive) || [];
          this.$refs['activeTable'].setTableData(this.pageSeasonFeesActive);
          this.$refs['futureTable'].setTableData(this.pageSeasonFeesFuture);
          this.$refs['pastTable'].setTableData(this.pageSeasonFeesPast);
          this.pageShowData = true;
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'fees data'));
        })
    },

    getUrl() {
      return helper.SERVER_URL + '/api2/season/' + this.pageSeason.id + '/seasonFees/';
    },

    onAddButtonClick() {
      try {
        // $('#jt-form-input-_StartDate').datepicker('setStartDate', new Date());
      } catch (e) {
      }

      this.activeButtonVisible = false;
      this.$refs['pageFeedback'].setFeedbackMessage();
      this.$refs['pageModal'].setModalOpen(true, 'Add New Product Fees');

      this.$nextTick(() => {
        this.$refs['pageModal'].$refs['modalForm'].$refs['jt-form-element-quarterly'][0].$refs['input'].updateTotal();
        this.$refs['pageModal'].$refs['modalForm'].$refs['jt-form-element-halfYearly'][0].$refs['input'].updateTotal();
        this.$refs['pageModal'].$refs['modalForm'].$refs['jt-form-element-annually'][0].$refs['input'].updateTotal();
      });
    },
    onTableDataClick(tableData, tableDataIndex) {
      this.deleteButtonVisible = !tableData[tableDataIndex].isPast && !tableData[tableDataIndex].isActive;
      this.activeButtonVisible = !tableData[tableDataIndex].isPast && !tableData[tableDataIndex].isActive && helper.hasPermission(this.permission + '.activate', false);
      
      this.$refs['pageFeedback'].setFeedbackMessage();
      this.$refs['pageModal'].modalCanDelete = this.deleteButtonVisible;
      this.$refs['pageModal'].setModalOpen(false, 'Edit Product Fees', tableData[tableDataIndex]);
      this.$nextTick(() => {
        this.$refs['pageModal'].$refs['modalForm'].$refs['jt-form-element-quarterly'][0].$refs['input'].updateTotal();
        this.$refs['pageModal'].$refs['modalForm'].$refs['jt-form-element-halfYearly'][0].$refs['input'].updateTotal();
        this.$refs['pageModal'].$refs['modalForm'].$refs['jt-form-element-annually'][0].$refs['input'].updateTotal();
      });
    },

    onTablePageChange() {

    },

    onModalAddDataClick(selectedData) {
      let startDate = helper.parseDateTime(selectedData['_StartDate']);
      if(!startDate) {
        this.$refs['pageModal'].setModalError('Invalid Product Fees Start Date');
        return;
      }

      if(this.pageSeasonFee && this.pageSeasonFee.length > 0) {
        if(startDate.date() !== 1 || startDate < moment().startOf('day')) {
          this.$refs['pageModal'].setModalError('Product Fees Start Date must be 1st of month and greater than today\'s date');
          return;
        }
      } else {
        if(startDate < helper.parseDateTime(this.pageSeason.startDate)) {
          this.$refs['pageModal'].setModalError('Product Fees Start Date must be greater than product start date (' + helper.formatDate(this.pageSeason.startDate) + ')');
          return;
        }
      }
      selectedData['startDate'] = startDate.unix();
      selectedData['seasonID'] = this.$route.query.productID;
      
      this.$refs['pageModal'].setModalLoading('Adding parking fees for ' + this.pageSeason.name);

      this.$http
        .post(
          this.getUrl(),
          querystring.stringify(selectedData),
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          if(startDate <= moment().startOf('day')) {
            // active fees if today
            this.$refs['pageModal'].$refs['modalForm'].formData['id'] = response.data[0].id;
            this.activateFees();
          } else {
            this.upsertDataComplete('Successfully added parking fees for ' + this.pageSeason.name);
          }
        })
        .catch(error => {
          this.$refs['pageModal'].setModalError(helper.parseAxiosErrorMessage(this, error, 'adding', 'parking fees'));
        })
    },
    onModalEditDataClick(selectedData) {
      this.$refs['pageModal'].setModalLoading('Updating parking fees for ' + this.pageSeason.name);

      this.$http
        .put(
          this.getUrl(),
          querystring.stringify(selectedData),
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.upsertDataComplete('Successfully update parking fees for' + this.pageSeason.name);
        })
        .catch(error => {
          this.$refs['pageModal'].setModalError(helper.parseAxiosErrorMessage(this, error, 'updating', 'parking fees'));
        })
    },
    onModalDeleteDataClick(selectedData) {
      this.$refs['pageModal'].setModalLoading('Deleting parking fees for ' + this.pageSeason.name);

      this.$http
        .delete(
          this.getUrl(selectedData.carparkID) + selectedData.id,
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.upsertDataComplete('Successfully delete parking fees for ' + this.pageSeason.name);
        })
        .catch(error => {
          this.$refs['pageModal'].setModalError(helper.parseAxiosErrorMessage(this, error, 'deleting', ' parking fees'));
        })
    },
    upsertDataComplete(message) {
      this.$refs['pageModal'].setModalClose();
      this.$refs['pageFeedback'].setFeedbackMessage(message);
      this.loadData();
    },

    onFormInput(formData, formParameter, input) {
      if(formParameter.key === 'monthly') {
        let monthlyFees = parseFloat(formData['monthly']);
        formData['quarterly'] = monthlyFees;
        formData['halfYearly'] = monthlyFees;
        formData['annually'] = monthlyFees;
        this.$refs['pageModal'].$refs['modalForm'].$refs['jt-form-element-quarterly'][0].$refs['input'].updateTotal();
        this.$refs['pageModal'].$refs['modalForm'].$refs['jt-form-element-halfYearly'][0].$refs['input'].updateTotal();
        this.$refs['pageModal'].$refs['modalForm'].$refs['jt-form-element-annually'][0].$refs['input'].updateTotal();
      } 
    },

    onActiveButtonClick() {
      let startDate = helper.parseDateTime(this.$refs['pageModal'].$refs['modalForm'].formData['_StartDate']);
      if(startDate.startOf('day').unix() !== moment().startOf('day').unix()) {
        this.activeModalDate = helper.formatDate(moment());
        $('#jt-product-active-date-modal').modal('show');
      } else {
        $('#jt-product-active-confirm-modal').modal('show');
      }
    },
    onChangeDateConfirmClick() {
      $('#jt-product-active-date-modal').modal('hide');
      return this.activateFees();
    },
    onActiveConfirmClick() {
      $('#jt-product-active-confirm-modal').modal('hide');
      return this.activateFees();
    },
    async activateFees() {
      for(let activeSeasonFees of this.pageSeasonFeesActive) {
        this.$refs['pageModal'].setModalLoading('Deactivating current parking fees');
        if(await this.$http
          .post(
            this.getUrl() + activeSeasonFees['id'] + '/deactivate',
            '',
            helper.createAxiosFormConfig()
          )
          .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
            this.$refs['pageModal'].setModalMessage('Succesfully deactivate current parking fees');
          })
          .catch(error => {
            this.$refs['pageModal'].setModalError(helper.parseAxiosErrorMessage(this, error, 'deactivating', 'parking fees'));
            return true;
          })) {
            return;
          }
      }

      this.$refs['pageModal'].setModalLoading('Setting parking fees to active');
      this.$http
        .post(
          this.getUrl() + this.$refs['pageModal'].$refs['modalForm'].formData['id'] + '/activate',
          '',
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageModal'].setModalClose();
          this.$refs['pageFeedback'].setFeedbackMessage('Succesfully set parking fees to active');
          this.loadData();
        })
        .catch(error => {
          this.$refs['pageModal'].setModalError(helper.parseAxiosErrorMessage(this, error, 'setting', 'parking fees to active'));
        })
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Page/CarPark/PageProductFees.vue